/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useCallback } from "react";
//import { useSelector } from "react-redux";
import { FormOutlined } from "@ant-design/icons";

import {
  GetListRoleModulePermissionsByCompanyService,
  SaveRolePermissionsService,
  GetListPermissionsRoleModulePermissionsByCompanyService,
} from "services/roles/services";

import SubmitButtonNoSubmit from "components/submitButton/SubmitButtonNoSubmit";
import Switch from "components/switchButton/Switch";
import { useNotifications } from "context/Notifications";
import { useTranslator } from "context/translator";
import Loading from "components/loading/Loading";
import PermissionsPanel from "components/permissions/permissionPanel/PermissionsPanel";
import { useModalMessageConfirmation } from "context/ModalMessageConfirmation";

export default function RolePermissionsModal({ openP, selectedRole, onClose }) {
  //const { user } = useSelector((state) => state.user);
  //const { data: company } = useGetCompanyQuery(user.companyId);

  const { AddNoti } = useNotifications();
  const { translate } = useTranslator();
  const [isLoading, setIsLoading] = useState(false);

  const [modalModuleOpen, SetModalModuleOpen] = useState(false);
  const [modalPermissionsOpen, SetModalPermissionsOpen] = useState(false);

  const [modulesPermissions, SetModulesPermissions] = useState([]);
  const [subModulePermissions, SetSubModulePermissions] = useState([]);
  const [initModuleCompleted, setInitModuleCompleted] = useState(false);
  const [initPermissionsCompleted, setInitPermissionsCompleted] =
    useState(false);
  const [selectedModule, setSelectedModule] = useState({});
  const [pendingChanges, SetPendingChanges] = useState(false);
  const [possiblePendingChanges, SetPossiblePendingChanges] = useState(false);

  const { ShowConfirm } = useModalMessageConfirmation(); // ShowMessage(message, title)  const response = Await ShowConfirm(message, title, btnAcceptText, focus (true=Accept | false=Cancel | null=None), btnCancelText)

  const ModalRolePermissionsCloseConfirm = useCallback(() => {
    ResetData();
    onClose(true);
  }, [onClose]);
  const ModalRolePermissionsClose = useCallback(async () => {
    if (pendingChanges) {
      const resultado = await ShowConfirm(
        translate("pending-changes-confirm"),
        translate("pending-changes"),
        null,
        false, // focus: true Accept | false Cancel | null None
        null,
      );

      if (resultado) {
        ModalRolePermissionsCloseConfirm();
      }
    } else {
      ModalRolePermissionsCloseConfirm();
    }
  }, [
    pendingChanges,
    ShowConfirm,
    translate,
    ModalRolePermissionsCloseConfirm,
  ]);

  const ModalRoleModulePermissionsClose = useCallback(() => {
    // closeExitModal

    //if (closeExitModal === true) {

    //    let replyAtLeastOne = ModuleSubModulesPermissionsAtLeastOneAllow(subModulePermissions);

    //    if (!replyAtLeastOne) {

    //        SwitchChangeModuleAllow(selectedModule, false, false);

    //        SetPermissionsModulesPermissions(selectedModule, null);

    //    }

    //}

    setSelectedModule({});
    SetSubModulePermissions([]);
    SetModalPermissionsOpen(false);
  }, [subModulePermissions]);

  const GetListRoleModulePermissionsByCompany = useCallback(() => {
    setIsLoading(true);

    let params = {
      companyId: selectedRole.companyId,
      roleId: selectedRole._id,
    };

    GetListRoleModulePermissionsByCompanyService(params).then((callback) => {
      if (callback.ok) {
        SetModulesPermissions(callback.obj);

        setInitModuleCompleted(true);
      } else {
        AddNoti(
          callback.msg != null ? translate(callback.msg) : "",
          translate("error-request-api"),
          2,
        );

        ModalRolePermissionsClose();
      }

      setIsLoading(false);
    });
  }, [AddNoti, translate, selectedRole]);

  //const ModalInit = useCallback(() => {

  //    ResetData();

  //    //if (modules.length === 0) {
  //    GetListRoleModulePermissionsByCompany();

  //    //}

  //}, [GetListRoleModulePermissionsByCompany]);

  const SwitchChangeModuleAllow = async (
    modItem,
    allow,
    showValidationOnDisabled,
  ) => {
    let continueAllow = false;

    if (allow) {
      let replyPermissions =
        await GetListPermissionsRoleModulePermissionsByCompany(
          modItem,
          false,
          false,
        );

      if (replyPermissions) {
        continueAllow = true;
      }
    } else {
      if (showValidationOnDisabled) {
        const resultado = await ShowConfirm(
          translate("selected-permissions-lose-on-disable-sub-module"),
          modItem.module.name,
          null,
          false, // focus: true Accept | false Cancel | null None
          null,
        );

        if (resultado) {
          continueAllow = true;
          SetPermissionsModulesPermissions(modItem, null);
        }
      } else {
        continueAllow = true;
      }
    }

    if (continueAllow) {
      //let modd = null;

      await SetModulesPermissions((prev) =>
        prev.map((modRecord) => {
          if (modRecord._id !== modItem._id) return modRecord;
          // si continúa, es el registro que necesito manipular, sino todo good, sale de una

          const mod = { ...modRecord };

          mod.allow = allow;

          //modd = { ...mod };

          //if (noDebeCambiarNada) return modRecord;
          return mod;
        }),
      );

      // Quitó todo lo que tuviera actualmente, de una tira cambio pendiente
      if (!allow) {
        SetPendingChanges(true);
      }
    }
  };

  const SetPermissionsModulesPermissions = async (
    modItem,
    subModulePermissions,
  ) => {
    //alert("mostrar alarta en caso de true");

    await SetModulesPermissions((prev) =>
      prev.map((modRecord) => {
        if (modRecord._id !== modItem._id) return modRecord;
        // si continúa, es el registro que necesito manipular, sino todo good, sale de una

        const mod = { ...modRecord };

        mod.subModulePermissions = subModulePermissions;

        //if (noDebeCambiarNada) return modRecord;
        return mod;
      }),
    );
  };

  useEffect(() => {
    SetModalModuleOpen(openP);

    if (!openP) {
      ResetData();
      return;
    }

    // si abre
    setInitModuleCompleted(false);
    ResetData();
    GetListRoleModulePermissionsByCompany();

    // OJO: aquí pones dependencias estables
  }, [openP]); // , onClose, selectedRole?._id, selectedRole?.companyId, AddNoti, translate

  useEffect(() => {
    if (initModuleCompleted === true) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [initModuleCompleted]);

  const ResetData = () => {
    // Resetear en predeterminado las demás variables para que al utilizar la funcionalidad, todo esté de 0
    // Setea únicamente todo lo de acá, no lo que recibe como parámetro
    SetModulesPermissions([]);
    SetPendingChanges(false);
    SetPossiblePendingChanges(false);
    //SetSubModulePermissions([]);
    //setSelectedModule({});
    //SetPendingChanges(false);
    //SetPossiblePendingChanges(false);
    //setInitModuleCompleted(false);
  };

  const ViewModulePermissions = function (mod) {
    //console.log("asd");

    setInitPermissionsCompleted(false);

    SetModalPermissionsOpen(true);

    setSelectedModule({ ...mod });

    GetListPermissionsRoleModulePermissionsByCompany(mod, true, true);
  };

  const GetListPermissionsRoleModulePermissionsByCompany = useCallback(
    async (mod, openModal, dbPermissionsAllow) => {
      let reply = false;

      if (
        mod.subModulePermissions !== undefined &&
        mod.subModulePermissions !== null
      ) {
        SetSubModulePermissions(mod.subModulePermissions);

        setInitPermissionsCompleted(true);

        reply = true;
      } else {
        setIsLoading(true);

        let params = {
          companyId: selectedRole.companyId,
          roleId: selectedRole._id,
          moduleId: mod.module._id,
          dbPermissionsAllow: dbPermissionsAllow, // TRUE: usa los de la base   | FALSE: marca todo en true, ya que está habilitando apenas
        };

        await GetListPermissionsRoleModulePermissionsByCompanyService(
          params,
        ).then(async (callback) => {
          if (callback.ok) {
            await SetPermissionsModulesPermissions(mod, callback.obj);

            if (openModal) {
              // Acá es solo cuando se necesite modificar los permisos de algún módulo
              SetSubModulePermissions(callback.obj);
            }

            setInitPermissionsCompleted(true);

            if (!dbPermissionsAllow) {
              SetPendingChanges(true);
            }

            reply = true;
          } else {
            AddNoti(
              callback.msg != null ? translate(callback.msg) : "",
              translate("error-request-api"),
              2,
            );

            ModalRoleModulePermissionsClose();
          }

          setIsLoading(false);
        });
      }

      return reply;
    },
    [AddNoti, translate, ModalRoleModulePermissionsClose, selectedRole],
  );

  const ModuleSubModulesPermissionsAtLeastOneAllow = function (
    subModulePermissions,
  ) {
    let reply = false;

    if (subModulePermissions !== undefined && subModulePermissions !== null) {
      subModulePermissions.forEach((value) => {
        if (value.allow) {
          reply = true;
        }
      });
    }

    return reply;
  };

  const SaveModuleRolePermissions = function () {
    if (possiblePendingChanges) {
      SetPendingChanges(true);
    }

    SetPermissionsModulesPermissions(selectedModule, subModulePermissions);

    let subSoduleAllowAtLeast =
      ModuleSubModulesPermissionsAtLeastOneAllow(subModulePermissions);

    // No tiene ningún permiso habilitado, ya que no tiene ningún sub-módulo habilitado, entonces se quita el módulo
    if (!subSoduleAllowAtLeast) {
      SwitchChangeModuleAllow(selectedModule, false, false);
      SetPermissionsModulesPermissions(selectedModule, null);
    }

    ModalRoleModulePermissionsClose();
  };

  const SaveRolePermissions = function () {
    setIsLoading(true);

    let newModulesPermissions = [];

    modulesPermissions.forEach((value) => {
      newModulesPermissions.push({
        ...value,
        module: null,
        subModulePermissions: value.allow ? value.subModulePermissions : null,
      });
    });

    let params = {
      companyId: selectedRole.companyId,
      roleId: selectedRole._id,
      modulesPermissions: newModulesPermissions,
    };

    SaveRolePermissionsService(params).then((callback) => {
      if (callback.ok) {
        AddNoti(translate(callback.msg), translate("error-request-api"), 1);

        SetPendingChanges(false);
        SetPossiblePendingChanges(false);

        //SetModulesPermissions(callback.obj);

        //setInitModuleCompleted(true);
      } else {
        AddNoti(
          callback.msg != null ? translate(callback.msg) : "",
          translate("error-request-api"),
          2,
        );
      }

      //ModalPermissionUserClose(); // no cerrar nada

      setIsLoading(false);
    });
  };

  return (
    <>
      {modalModuleOpen && (
        <div
          id="modalID"
          tabIndex="-1"
          aria-hidden="true"
          className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-full bg-black bg-opacity-50 overflow-y-auto"
        >
          <div className="relative p-4 w-full max-w-2xl max-h-full">
            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
              <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                  {translate("permissions")} - {selectedRole?.description}
                </h3>
                <button
                  type="button"
                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-hide="modalID"
                  onClick={ModalRolePermissionsClose}
                  disabled={isLoading}
                >
                  <svg
                    className="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span className="sr-only"> Close modal </span>
                </button>
              </div>
              <div className="p-4 md:p-5">
                {isLoading && !initModuleCompleted ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                    {translate("loading-data")}
                  </div>
                ) : (
                  //) : employeeData.length === 0 ? (
                  //    <NoResults message="No members found" />
                  <div>
                    <div className="grid gap-6 md:grid-cols-2">
                      {modulesPermissions.map((mod) => (
                        <div key={mod._id}>
                          <div>
                            <div className="switch-middle-align">
                              <div className="grid gap-3 mb-6 grid-cols-3">
                                <div className="dark:text-white col-span-2">
                                  <label> {translate(mod.module.name)} </label>

                                  {mod.allow && (
                                    <span>
                                      &nbsp;
                                      <button
                                        type="button"
                                        onClick={() =>
                                          ViewModulePermissions(mod)
                                        }
                                        title={translate("permissions")}
                                        disabled={isLoading}
                                      >
                                        <FormOutlined
                                          className="w-6 h-6 text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300"
                                          style={{ fontSize: "19px" }}
                                        />
                                      </button>
                                    </span>
                                  )}
                                </div>
                                <div>
                                  <Switch
                                    value={mod.allow}
                                    onChange={(newValue) =>
                                      SwitchChangeModuleAllow(
                                        mod,
                                        newValue,
                                        true,
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <br />

                    <div className="grid gap-6 mb-1 grid-cols-2">
                      <div style={{ color: "indianred" }}>
                        {pendingChanges && (
                          <div>*{translate("pendingChanges")}</div>
                        )}
                      </div>
                      <div>
                        <SubmitButtonNoSubmit
                          isLoading={isLoading}
                          textLoading={translate("saving")}
                          text={translate("save")}
                          onClick={SaveRolePermissions}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Este modal solo va a tener los permisos del MOMENTO, pero tienen que retornarse al objeto (módulo) que le corresponde  */}
      {modalPermissionsOpen && (
        <div
          id="modalID"
          tabIndex="-1"
          aria-hidden="true"
          className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-full bg-black bg-opacity-50 overflow-y-auto"
        >
          <div className="relative p-4 w-full max-w-2xl max-h-full">
            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
              <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                  {translate("permissions")} - {selectedRole?.description} -{" "}
                  {translate(selectedModule?.module?.name)}
                  {/*<button type="button" onClick={Consolee()} ></button>*/}
                </h3>
                <button
                  type="button"
                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-hide="modalID"
                  onClick={() => ModalRoleModulePermissionsClose()}
                  disabled={isLoading}
                >
                  <svg
                    className="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span className="sr-only"> Close modal </span>
                </button>
              </div>
              <div className="p-4 md:p-5">
                {isLoading && !initPermissionsCompleted ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                    {translate("loading-data")}
                  </div>
                ) : (
                  //) : employeeData.length === 0 ? (
                  //    <NoResults message="No members found" />
                  <div>
                    <div className="grid gap-6 md:grid-cols-1">
                      <PermissionsPanel
                        openP={modalPermissionsOpen}
                        subModulos={subModulePermissions}
                        setSubModulos={SetSubModulePermissions}
                        onDirty={() => SetPossiblePendingChanges(true)}
                      />
                    </div>

                    <br />

                    <div className="grid gap-6 mb-1 grid-cols-1">
                      <div>
                        <SubmitButtonNoSubmit
                          isLoading={isLoading}
                          textLoading={translate("saving")}
                          text={translate("save")}
                          onClick={SaveModuleRolePermissions}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
